
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';

export default function DialogBox(props) {
  const { 
    confirmDialog, 
    setConfirmDialog, 
    onConfirm, 
    onCancel 
  } = props;

  const handleClose = () => {
    setConfirmDialog({ ...confirmDialog, isOpen: false });
  };

  return (
    <Dialog open={confirmDialog.isOpen} onClose={handleClose}
    sx={{ 
      '& .MuiPaper-root': { 
        borderRadius: '16px', 
        padding: '16px', 
        backgroundColor: '#f5f5f5',
        width: '400px',  // Fixed width
        maxWidth: '500px',  // Maximum width 
        zIndex: '40px'
      } 
    }}>
      <DialogTitle sx={{ color: '#1976d2', fontWeight: 'bold' }}>{confirmDialog.title || 'Confirmation'}</DialogTitle>
      <DialogContent>
        <Typography variant='h7' sx={{ color: '#333' }}>{confirmDialog.subtitle || 'Are you sure?'}</Typography>
      </DialogContent>
      <DialogActions>
        
        <Button 
          id="rowsPerPageButton"
          onClick={() => {
            if (onConfirm) onConfirm();
            handleClose();
          }} 
          autoFocus
          // sx={{ color: '#388e3c', fontWeight: 'bold' }}
        >
          Yes
        </Button>
        <Button 
        id="clearUserLogButton"
          onClick={() => {
            if (onCancel) onCancel();
            handleClose();
          }}
          // sx={{ color: '#d32f2f', fontWeight: 'bold' }}
        >
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}
